export const USE_CLOCK_TICK_INTERVAL_MS = 1000;

export const USE_COPY_ID_ANIMATE_RESET_DELAY_MS = 300;

export const USE_IFRAME_HEIGHT_DEBOUNCE_MS = 100;

export const HOOKS_MEDIUM_DESKTOP_BREAKPOINT_PX = 1500;
export const HOOKS_LARGE_DESKTOP_BREAKPOINT_PX = 1700;
